import { useEffect, useState } from 'react';

export default function SkipLink() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        setIsVisible(true);
      }
    };

    const handleBlur = () => {
      setTimeout(() => setIsVisible(false), 100);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  const skipToContent = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={skipToContent}
      className={`fixed top-4 left-4 z-[9999] bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold shadow-xl transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-teal-300 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-20 opacity-0'
      }`}
      style={{ 
        clipPath: isVisible ? 'none' : 'inset(0)',
      }}
    >
      Pular para o conteúdo principal
    </a>
  );
}